export default __webpack_public_path__ + "static/media/modern.ef1fe9ec.jpg";